module.exports = "/_next/static/images/b92544b8c584e1d5a5076a51b3e17b17-nubanker-ds@0.75x.jpg.webp";